export default function()
{
    const self = this;

    /**
     * Cut off a string after # characters
     * @param string
     * @param length The maximum amount of characters
     * @param append What to append after the trimmed text
     */
    self.cutOffString = (string, length, append = '&hellip;') => {
        if (string === undefined) {
            return '';
        }

        // Cut off if longer than the maximum
        if (string.length > length) {
            return string.slice(0, length) + append;
        }

        return string;
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/Utils.js